import { useEffect } from "react";
import { clientLogger } from "@/utils/clientLogger";

export const useScrollToHash = (isLoading: boolean) => {
  useEffect(() => {
    if (!isLoading) {
      const hash = window.location.hash;
      if (hash) {
        try {
          const id = decodeURIComponent(hash.substring(1));
          const element = document.getElementById(id);

          if (element) {
            setTimeout(() => {
              element.scrollIntoView({ behavior: "smooth" });
            }, 200);
          }
        } catch (e) {
          clientLogger.debug("Failed to scroll to hash:", e);
        }
      }
    }
  }, [isLoading]);
};
